export default __webpack_public_path__ + "static/media/amazon.8136aad6.png";